import { BlockListRender, DME, dmeConfig } from "dmeditor";

export interface LatestEnitity {
  list: Array<any>;
  limit: number;
  location?: string;
  locationName?: string;
}

export const Latest = (props: DME.WidgetRenderProps<LatestEnitity>) => {
  const {
    blockNode: { data },
  } = props;

  const list = data.list || [{ id: 0, name: "test", modified: 0, images: [] }];

  return (
    <div>
      {props.blockNode.children && (
        <BlockListRender
          blockData={props.blockNode.children || []}
          path={props.path}
          mode={props.mode}
        />
      )}
      <div className="grid grid-cols-3 gap-1">
        {list.map((item: any, index: number) => (
          <div key={item.id} className="pb-2">
            <a href={"/app/school/" + item.id}>
              {item.images.length > 0 && (
                <div>
                  <img src={dmeConfig.general.imagePath(item.images[0])} />
                </div>
              )}
              <h2 className="text-xl">{item.name}</h2>
            </a>
            <div className="text-gray-500">
              Updated: {new Date(item.modified).toDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
